<template>
  <div class="edit-col">
    <text-input
      v-if="isTextInputType"
      :id="row['invoiceNumber']"
      :error="validateSfdcRow(row, col, '', { disputeReasons })"
      :error-message="
        validateSfdcRow(row, col, '', { disputeReasons })
          ? sfdcValidationTypes[col.slotKey].errorMessage
          : ''
      "
      :value="row[col.slotKey]"
      @onChange="onTextChange($event)" />
    <text-area
      v-if="isTextAreaType"
      id="text-area"
      :error="validateSfdcRow(row, col, '', { disputeReasons })"
      :error-message="
        validateSfdcRow(row, col, '', { disputeReasons })
          ? sfdcValidationTypes[col.slotKey].errorMessage
          : ''
      "
      :help-message="helpMessageTextArea"
      :max-length="sfdcValidationTypes[col.slotKey].maxValue"
      :value="row[col.slotKey] || ''"
      help-message-position="right"
      @onChange="onCommentsChange" />
  </div>
</template>

<script>
import { validateSfdcRow } from "@/utils/helpers.js";
import { sfdcValidationTypes } from "@/config/sfdcConstant.js";
export default {
  name: "EditComponent",
  props: {
    row: { type: Object, default: () => {} },
    col: { type: Object, default: () => {} },
    disputeReasons: { type: Array, default: () => [] },
  },
  data() {
    return {
      validateSfdcRow,
      sfdcValidationTypes,
    };
  },
  computed: {
    isTextAreaType() {
      return (
        this.sfdcValidationTypes?.[this?.col.slotKey]?.validationType ===
        "textArea"
      );
    },
    isTextInputType() {
      return (
        this.sfdcValidationTypes?.[this.col?.slotKey]?.validationType ===
          "input" ||
        this?.sfdcValidationTypes[this?.col.slotKey]?.validationType === "email"
      );
    },
    helpMessageTextArea() {
      return `${this.row?.[this.col.slotKey]?.length || 0}/${
        this.sfdcValidationTypes[this.col.slotKey].maxValue
      }`;
    },
  },
  methods: {
    onCommentsChange(event) {
      this.$emit("onCommentsUpdate", event, this.row);
    },
    onTextChange(event) {
      this.$emit(
        "onTextInputUpdate",
        event?.target.value,
        this.row,
        this.col?.slotKey
      );
    },
  },
};
</script>
<style lang="scss">
.table-flex__row__cell {
  height: unset !important;
}
.edit-col {
  #text-area {
    width: 400px;
    padding-right: 20px;
  }
  .form-input__field {
    height: auto;
  }
}
</style>
